<script lang="ts">
  import Button from '../ui/Button.svelte';
  import { MODE_INFO } from '../content/modes';
  import type { GameMode } from '../../shared/modes';
  import type { GameConfig } from '../../shared/config';
  import type { PlayerView } from '../../shared/protocol';

  interface Props {
    mode: GameMode;
    isHost: boolean;
    players: readonly Readonly<PlayerView>[];
    config: GameConfig;
    startRound: () => void;
    leaveRoom: () => void;
  }
  let { mode, isHost, players, config, startRound, leaveRoom }: Props = $props();
</script>

<div class="lobby-control-bar">
  {#if mode !== 'versus'}<p class="hint">{MODE_INFO[mode].rules}</p>{/if}
  <div class="lobby-control-row">
    {#if isHost}<Button variant="primary" size="big" full onclick={startRound}>Start Round</Button>{/if}
    <Button size="big" full onclick={leaveRoom}>Leave</Button>
  </div>
  {#if !isHost || (mode === 'versus' && players.length > 1)}
    <p class="status">
      {isHost
        ? `${players.length} of ${config.maxPlayers} here · you're the host`
        : `waiting for ${players.find((player) => player.host)?.name ?? 'the host'} to start`}
    </p>
  {/if}
</div>

<style>
  .lobby-control-bar {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }
  .lobby-control-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
  }
  /* Labels stay on one line; below ~2×140px (320px phones) the pair stacks instead. */
  .lobby-control-row :global(.btn) {
    flex: 1 1 140px;
    white-space: nowrap;
  }
</style>
